import { cn } from '@listening/utils/react-helpers';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { Circle } from 'iconoir-react';
import type * as React from 'react';

const RadioGroup = ({
  ref,
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root> & {
  ref?: React.RefObject<React.ComponentRef<
    typeof RadioGroupPrimitive.Root
  > | null>;
}) => (
  <RadioGroupPrimitive.Root
    className={cn('grid gap-2', className)}
    {...props}
    ref={ref}
  />
);
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

const RadioGroupItem = ({
  ref,
  className,
  indicatorClassName,
  ...props
}: React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item> & {
  indicatorClassName?: string;
} & {
  ref?: React.RefObject<React.ComponentRef<
    typeof RadioGroupPrimitive.Item
  > | null>;
}) => (
  <RadioGroupPrimitive.Item
    className={cn(
      'aspect-square h-4 w-4 rounded-full border border-primary text-primary ring-offset-background focus:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
      className,
    )}
    ref={ref}
    {...props}
  >
    <RadioGroupPrimitive.Indicator
      className={cn('flex items-center justify-center', indicatorClassName)}
    >
      <Circle className='size-2.5 fill-current text-current' />
    </RadioGroupPrimitive.Indicator>
  </RadioGroupPrimitive.Item>
);
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioGroup, RadioGroupItem };
